module.exports = __webpack_public_path__ + "img/moon.d75dc825.svg";